package fr.manyverse.app.domain.usecase.userconfig

import fr.manyverse.app.domain.repository.UserConfigRepository

class AcceptTermsUseCase(private val repository: UserConfigRepository) {
    suspend operator fun invoke(userId: String): Result<Unit> =
        repository.upsertTermsAcceptance(userId)
}
